import React, { useState } from 'react'
import axios from 'axios'
import logo from '../Image/logo.png'
function PhonepePay() {
    const [form, setForm] = useState({
        amount: '',
        email: '',
        phone: '',
        domainName: '',
        companyName: ''
    })
    const [errors, setErrors] = useState({})
    const [submitting, setSubmitting] = useState(false)
    const [apiError, setApiError] = useState('')

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
        setErrors({ ...errors, [e.target.name]: '' })
        setApiError('')
    }

    const validate = () => {
        const err = {}
        if (!form.amount || isNaN(form.amount) || Number(form.amount) <= 0)
            err.amount = 'Please enter a valid amount'
        if (!form.phone || form.phone.length < 10)
            err.phone = 'Please enter a valid 10-digit phone number'
        return err
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const err = validate()
        if (Object.keys(err).length > 0) {
            setErrors(err)
            return
        }

        setSubmitting(true)
        setApiError('')

        try {
            const response = await axios.post('https://api.ndtechland.com/api/PaymentGatway/GeneratePaymentLink', {
                amount: parseFloat(form.amount),
                redirectUrl: window.location.origin + '/payment-status', // Use working redirectUrl path
                mobileNumber: form.phone || '9999999999', // Optional
                merchantId: 'PGTESTPAYUAT86' // Use correct merchant account ID
            });

            const responseData = response.data;
            const paymentUrl = responseData?.paymentUrl || responseData?.url || responseData?.data?.paymentLink || responseData?.data?.url;
            const txnId = responseData?.transactionId || responseData?.data?.transactionId || responseData?.merchantTransactionId || '';

            if (paymentUrl) {
                // Save transactionId in localStorage to check status later
                if (txnId) {
                    localStorage.setItem('lastTxnId', txnId);
                }
                localStorage.setItem('lastAmount', form.amount);
                localStorage.setItem('lastMerchantId', 'PGTESTPAYUAT86');
                
                // Redirect user to PhonePe checkout page
                window.location.href = paymentUrl;
            } else {
                setApiError('Payment failed to initiate: ' + (response.data.message || 'Unknown reason'));
                setSubmitting(false);
            }
        } catch (error) {
            console.error('Payment API Error:', error);
            setApiError(error.response?.data?.message || error.message || 'Something went wrong. Please try again.');
            setSubmitting(false);
        }
    }

    const displayAmount = form.amount && !isNaN(form.amount)
        ? `₹ ${parseFloat(form.amount).toFixed(2)}`
        : '₹ 0.00'


    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

                * { box-sizing: border-box; margin: 0; padding: 0; }

                .pp-page {
                    min-height: 100vh;
                    background: #f5f6fa;
                    font-family: 'Inter', sans-serif;
                }

                .pp-topbar {
                    background: #fff;
                    border-bottom: 1px solid #e8eaf0;
                    padding: 14px 40px;
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
                }

                .pp-topbar-logo {
                    width: 56px;
                    height: 56px;
                    border: 1px solid #e0e0e0;
                    border-radius: 6px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    background: #fff;
                    padding: 4px;
                }

                .pp-topbar-logo img {
                    width: 100%;
                    object-fit: contain;
                }

                .pp-topbar-name {
                    font-size: 18px;
                    font-weight: 700;
                    color: #1a1a2e;
                    letter-spacing: 0.2px;
                }

                .pp-body {
                    max-width: 1000px;
                    margin: 48px auto;
                    padding: 0 20px;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 36px;
                    align-items: start;
                }

                @media (max-width: 768px) {
                    .pp-body { grid-template-columns: 1fr; margin: 24px auto; }
                    .pp-topbar { padding: 14px 20px; }
                }

                /* Left Panel */
                .pp-left h2 {
                    font-size: 26px;
                    font-weight: 700;
                    color: #1a1a2e;
                    margin-bottom: 6px;
                }

                .pp-underline {
                    width: 40px;
                    height: 3px;
                    background: #5b21b6;
                    border-radius: 2px;
                    margin-bottom: 22px;
                }

                .pp-left p {
                    font-size: 13.5px;
                    color: #555;
                    line-height: 1.75;
                    margin-bottom: 24px;
                }

                .pp-left p strong {
                    color: #1a1a2e;
                    font-weight: 600;
                }

                .pp-contact-title {
                    font-size: 14px;
                    font-weight: 700;
                    color: #1a1a2e;
                    margin-bottom: 10px;
                }

                .pp-contact-item {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    font-size: 13px;
                    color: #444;
                    margin-bottom: 8px;
                }

                .pp-contact-item i {
                    color: #5b21b6;
                    width: 16px;
                    font-size: 13px;
                }

                .pp-terms-title {
                    font-size: 14px;
                    font-weight: 700;
                    color: #1a1a2e;
                    margin-top: 22px;
                    margin-bottom: 8px;
                }

                .pp-terms-text {
                    font-size: 12.5px;
                    color: #777;
                    line-height: 1.7;
                    margin-bottom: 0 !important;
                }

                .pp-terms-text a {
                    color: #5b21b6;
                    text-decoration: none;
                }

                /* Right Panel */
                .pp-card {
                    background: #fff;
                    border-radius: 10px;
                    border: 1px solid #e4e4e4;
                    overflow: hidden;
                    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
                }

                .pp-card-header {
                    padding: 20px 24px 14px;
                    border-bottom: 1px solid #f0f0f0;
                }

                .pp-card-header h3 {
                    font-size: 17px;
                    font-weight: 700;
                    color: #1a1a2e;
                    margin-bottom: 6px;
                }

                .pp-card-body {
                    padding: 20px 24px;
                }

                .pp-field {
                    display: grid;
                    grid-template-columns: 130px 1fr;
                    align-items: center;
                    margin-bottom: 18px;
                    gap: 12px;
                }

                .pp-field label {
                    font-size: 13px;
                    color: #444;
                    font-weight: 500;
                    line-height: 1.4;
                }

                .pp-field label .req {
                    color: #e53e3e;
                    margin-left: 2px;
                }

                .pp-input-wrap {
                    position: relative;
                    display: flex;
                    align-items: center;
                }

                .pp-rupee {
                    position: absolute;
                    left: 12px;
                    color: #5b21b6;
                    font-size: 14px;
                    font-weight: 600;
                    font-family: 'Inter', sans-serif;
                }

                .pp-input {
                    width: 100%;
                    border: 1px solid #d0d0d0;
                    border-radius: 5px;
                    padding: 10px 12px;
                    font-size: 13.5px;
                    color: #222;
                    font-family: 'Inter', sans-serif;
                    outline: none;
                    transition: border-color 0.2s;
                    background: #fff;
                }

                .pp-input:focus {
                    border-color: #5b21b6;
                    box-shadow: 0 0 0 3px rgba(91,33,182,0.08);
                }

                .pp-input.has-prefix {
                    padding-left: 28px;
                }

                .pp-input.error {
                    border-color: #e53e3e;
                }

                .pp-phone-wrap {
                    display: flex;
                    width: 100%;
                    border: 1px solid #d0d0d0;
                    border-radius: 5px;
                    overflow: hidden;
                    transition: border-color 0.2s;
                }

                .pp-phone-wrap:focus-within {
                    border-color: #5b21b6;
                    box-shadow: 0 0 0 3px rgba(91,33,182,0.08);
                }

                .pp-phone-wrap.error { border-color: #e53e3e; }

                .pp-phone-prefix {
                    padding: 10px 12px;
                    background: #f5f5f5;
                    border-right: 1px solid #d0d0d0;
                    font-size: 13px;
                    color: #555;
                    white-space: nowrap;
                    font-family: 'Inter', sans-serif;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }

                .pp-phone-input {
                    flex: 1;
                    border: none;
                    padding: 10px 12px;
                    font-size: 13.5px;
                    color: #222;
                    font-family: 'Inter', sans-serif;
                    outline: none;
                }

                .pp-error-msg {
                    font-size: 11px;
                    color: #e53e3e;
                    margin-top: 4px;
                    grid-column: 2;
                    margin-left: 0;
                }

                .pp-card-footer {
                    border-top: 1px solid #f0f0f0;
                    padding: 14px 24px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 12px;
                }

                .pp-payment-logos {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    flex-wrap: wrap;
                }

                .pp-pay-badge {
                    background: #f5f5f5;
                    border: 1px solid #e0e0e0;
                    border-radius: 4px;
                    padding: 3px 8px;
                    font-size: 10px;
                    font-weight: 700;
                    color: #333;
                    display: flex;
                    align-items: center;
                    gap: 3px;
                }

                .pp-pay-badge.upi { color: #5b21b6; }
                .pp-pay-badge.visa { color: #1a1f6c; }
                .pp-pay-badge.mc { color: #eb001b; }
                .pp-pay-badge.rupay { color: #1c5f2e; }
                .pp-pay-badge.phonepe { color: #5b21b6; background: #f0ebff; border-color: #d6c8f7; }

                .pp-pay-btn {
                    background: linear-gradient(135deg, #5b21b6, #7c3aed);
                    color: #fff;
                    border: none;
                    border-radius: 6px;
                    padding: 12px 24px;
                    font-size: 14px;
                    font-weight: 700;
                    font-family: 'Inter', sans-serif;
                    cursor: pointer;
                    white-space: nowrap;
                    transition: all 0.2s;
                    box-shadow: 0 4px 12px rgba(91,33,182,0.3);
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }

                .pp-pay-btn:hover {
                    background: linear-gradient(135deg, #4c1d95, #6d28d9);
                    transform: translateY(-1px);
                    box-shadow: 0 6px 16px rgba(91,33,182,0.4);
                }

                .pp-pay-btn:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                    transform: none;
                }

                .pp-phonepe-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    background: #f0ebff;
                    border: 1px solid #c4b5fd;
                    border-radius: 20px;
                    padding: 4px 12px;
                    font-size: 11px;
                    font-weight: 600;
                    color: #5b21b6;
                    margin-bottom: 20px;
                }

                .pp-secure-note {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    font-size: 11px;
                    color: #999;
                    margin-top: 10px;
                }
            `}</style>

            <div className="pp-page">
                {/* Top Bar */}
                <div className="pp-topbar">
                    <div className="pp-topbar-logo">
                        <img src={logo} alt="ND Techland" />
                    </div>
                    <span className="pp-topbar-name">N D TECHLAND PRIVATE LIMITED</span>
                </div>

                {/* Body */}
                <div className="pp-body">

                    {/* Left: Info */}
                    <div className="pp-left">
                        <div className="pp-phonepe-badge">
                            <i className="fas fa-mobile-alt"></i>
                            PhonePe Payment
                        </div>
                        <h2>Online Payment</h2>
                        <div className="pp-underline"></div>

                        <p>
                            <strong>N D Techland</strong> is appraised as one of the top web development
                            agencies in India by different industry magazines and survey destinations.
                            We have a correct mix of grant winning designers, master web designers which
                            make us a special one-stop answer for many our customers, spread across 80+
                            nations. We're obsessed on quality. We depend on our portfolio to work together
                            and consistently guarantee that every one of our web or mobile deliverable is
                            remarkable and world class.
                        </p>

                        <p className="pp-contact-title">Contact Us:</p>
                        <div className="pp-contact-item">
                            <i className="fas fa-envelope"></i>
                            info@ndtechland.com
                        </div>
                        <div className="pp-contact-item">
                            <i className="fas fa-phone-alt"></i>
                            0120-4207742
                        </div>

                        <p className="pp-terms-title">Terms &amp; Conditions:</p>
                        <p className="pp-terms-text">
                            You agree to share information entered on this page with{' '}
                            <a href="#">N D TECHLAND PRIVATE LIMITED</a> (owner of this page) and
                            PhonePe, adhering to applicable laws.
                        </p>

                        <div className="pp-secure-note" style={{ marginTop: '20px' }}>
                            <i className="fas fa-shield-alt" style={{ color: '#22c55e' }}></i>
                            Secured by PhonePe · 256-bit SSL Encryption
                        </div>
                    </div>

                    {/* Right: Payment Card */}
                    <div className="pp-card">
                        <div className="pp-card-header">
                            <h3>Payment Details</h3>
                            <div className="pp-underline"></div>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="pp-card-body">

                                {/* Amount */}
                                <div className="pp-field">
                                    <label>Amount <span className="req">*</span></label>
                                    <div>
                                        <div className="pp-input-wrap">
                                            <span className="pp-rupee">₹</span>
                                            <input
                                                type="number"
                                                name="amount"
                                                value={form.amount}
                                                onChange={handleChange}
                                                placeholder="Enter Amount"
                                                className={`pp-input has-prefix ${errors.amount ? 'error' : ''}`}
                                                min="1"
                                            />
                                        </div>
                                        {errors.amount && <p className="pp-error-msg">{errors.amount}</p>}
                                    </div>
                                </div>

                                {/* Phone */}
                                <div className="pp-field">
                                    <label>Phone Number <span className="req">*</span></label>
                                    <div>
                                        <div className={`pp-phone-wrap ${errors.phone ? 'error' : ''}`}>
                                            <span className="pp-phone-prefix">
                                                <img
                                                    src="https://flagcdn.com/16x12/in.png"
                                                    alt="IN"
                                                    style={{ width: '16px', height: '12px' }}
                                                />
                                                IN +91
                                            </span>
                                            <input
                                                type="tel"
                                                name="phone"
                                                value={form.phone}
                                                onChange={handleChange}
                                                placeholder="10-digit mobile number"
                                                className="pp-phone-input"
                                                maxLength={10}
                                            />
                                        </div>
                                        {errors.phone && <p className="pp-error-msg">{errors.phone}</p>}
                                    </div>
                                </div>

                                {/* Email */}
                                <div className="pp-field">
                                    <label>Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={form.email}
                                        onChange={handleChange}
                                        placeholder=""
                                        className="pp-input"
                                    />
                                </div>

                                {/* Domain Name */}
                                <div className="pp-field">
                                    <label>Domain Name</label>
                                    <input
                                        type="text"
                                        name="domainName"
                                        value={form.domainName}
                                        onChange={handleChange}
                                        className="pp-input"
                                    />
                                </div>

                                {/* Company Name */}
                                <div className="pp-field">
                                    <label>Company Name</label>
                                    <input
                                        type="text"
                                        name="companyName"
                                        value={form.companyName}
                                        onChange={handleChange}
                                        className="pp-input"
                                    />
                                </div>

                            </div>


                            {/* Footer */}
                            <div className="pp-card-footer">
                                <div className="pp-payment-logos">
                                    <span className="pp-pay-badge upi">UPI</span>
                                    <span className="pp-pay-badge visa">VISA</span>
                                    <span className="pp-pay-badge mc">
                                        <i className="fas fa-circle" style={{ fontSize: '9px' }}></i>
                                        MC
                                    </span>
                                    <span className="pp-pay-badge rupay">RuPay</span>
                                    <span className="pp-pay-badge phonepe">
                                        <i className="fas fa-mobile-alt" style={{ fontSize: '9px' }}></i>
                                        PhonePe
                                    </span>
                                </div>
                                <button
                                    type="submit"
                                    className="pp-pay-btn"
                                    disabled={submitting}
                                >
                                    {submitting ? (
                                        <><i className="fas fa-spinner fa-spin"></i> Processing...</>
                                    ) : (
                                        <>Pay {displayAmount}</>
                                    )}
                                </button>
                            </div>

                            {/* API Error */}
                            {apiError && (
                                <div style={{
                                    margin: '0 24px 16px',
                                    padding: '10px 14px',
                                    background: '#fff5f5',
                                    border: '1px solid #fed7d7',
                                    borderRadius: '6px',
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: '8px'
                                }}>
                                    <i className="fas fa-exclamation-circle" style={{ color: '#e53e3e', fontSize: '13px', marginTop: '1px', flexShrink: 0 }}></i>
                                    <span style={{ fontSize: '12px', color: '#c53030', lineHeight: 1.5 }}>{apiError}</span>
                                </div>
                            )}
                        </form>
                    </div>

                </div>
            </div>
        </>
    )
}

export default PhonepePay
